// extracted by mini-css-extract-plugin
export var active = "header-module--active--FBUqQ";
export var deck = "header-module--deck--2Q6ys";
export var root = "header-module--root--KN7h8";